import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'

const Roulette = ({
    setRoulettePrize,
    setRouletteValue,
    wasActive,
    setWasActive
}) => {
    const [isRotating, setIsRotating] = useState(false);
    const [finalAngle, setFinalAngle] = useState(0);
    const [newAngleRou, setNewAngleRou] = useState(0);
    const [prizeSelect, setPrizeSelect] = useState(0);

    const prizes = [
        { id: 1, text: '2 Jugadas', value: 2 },
        { id: 2, text: '3 Jugadas', value: 3 },
        { id: 3, text: '5 Jugadas', value: 5 },
        { id: 4, text: '2 Jugadas', value: 2 },
        { id: 5, text: '10 Jugadas', value: 10 },
        { id: 6, text: '3 Jugadas', value: 3 },
        { id: 7, text: '2 Jugadas', value: 2 },
        { id: 8, text: '5 Jugadas', value: 5 },
        { id: 9, text: '4 Jugadas', value: 4 },
        { id: 10, text: '5 Jugadas', value: 5 },
    ];

    useEffect(() => {
        renderItems()
    }, []);

    const renderItems = () => {
        const container = document.getElementById('items_content');
        prizes?.map((item) => {
            const prizeItem = document.createElement('div');
            prizeItem.classList.add('item');
            const text = document.createTextNode(`${item?.text}`);
            prizeItem.appendChild(text);

            const spanElement = document.createElement('span');
            prizeItem.appendChild(spanElement);
            prizeItem.style.transform = `translate(0, -50%) rotate(-${((item?.id - 1) * 36)}deg)`;

            container.appendChild(prizeItem);
        })
    }

    const handleSpin = () => {
        if (isRotating) { return; }

        const prize = Math.floor((Math.random() * (9 - 0 + 1)) + 0);
        let newAngle = 2520;
        let newAngle2 = (prizeSelect > prize) ? (360 - ((prizeSelect - prize) * 36)) : (prizeSelect < prize) ? ((prize - prizeSelect) * 36) : 0;
        newAngle += newAngle2;

        setNewAngleRou(newAngle);
        setPrizeSelect(prize);
        setIsRotating(true);
        setWasActive(true);

        setTimeout(() => {
            setIsRotating(false);
            setFinalAngle((prevAngle) => prevAngle + newAngle);
            setRoulettePrize(prizes[prize].text);
            setRouletteValue(prizes[prize].value);
        }, 5000);
    };

    return (
        <RouletteContainer angle={finalAngle} newAngle={newAngleRou}>
            <div
                id='items_content'
                className={`items-content ${isRotating ? 'rotate' : ''}`}
                style={{ transform: `rotate(${finalAngle}deg)` }}
            ></div>
            <div className='market'></div>
            <button className='button' disabled={wasActive} onClick={handleSpin}>Girar</button>
        </RouletteContainer>
    )
}
const rotate = (angle, newAngle) => keyframes`
    0% { transform: rotate(${angle}deg); }
    100% { transform: rotate(${newAngle + angle}deg); }
`;
const RouletteContainer = styled.div`
    width: 440px;
    max-width: 90%;
    aspect-ratio: 1/1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #e36807;
    border-radius 50%;
    overflow: hidden;
    border: 12px dotted #f5fa42;

    .market {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 1em 0 1.3em 1.5em;
        border-color: transparent transparent transparent #f4f4f4;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0%, -50%);
        filter: drop-shadow(0.2em 0.2em 0 rgba(0, 0, 0, 0.25));
        @media (max-width: 576px) {
            border-width: .8em 0 1em 1.3em;
        }
    }

    .button {
        margin: 0;
        padding: 0;
        border: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 30%;
        height: 30%;
        border-radius: 50%;
        font-weight: 800;
        background: #FFF;
        cursor: pointer;
        user-select: none;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: rgba(28, 28, 28, 1) 0px 0px 30px 0px, 
                    rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
        &:disabled {
            color: #ccc;
        }
    }

    .items-content {
        width: 100%;
        height: 100%;
        position: relative;
        &.rotate {
            animation: ${(props) => rotate(props.angle, props.newAngle)} 5s ease-in-out;
            animation-fill-mode: forwards;
        }
    }

    .item {
        width: 50%;
        height: 33%;
        background: rgb(0,0,0);
        background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(143,8,8,1) 1%, rgba(201,29,29,1) 25%, rgba(214,34,34,1) 50%, rgba(214,34,34,1) 75%, rgba(145,9,9,1) 99%, rgba(0,0,0,1) 100%);
        clip-path: polygon(0% 0, 100% 50%, 0% 100%);
        padding: 0 0 0 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        transform-origin: right center 0px;
        position: absolute;
        top: 50%;
        left: 0;
        color: #FFF;
        font-size: 1.2rem;
        font-family: Impact;
        letter-spacing: 2px;
        @media (max-width: 576px) {
            font-size: 1rem;
        }
    }
`

export default Roulette